import { useDispatch, useSelector } from "react-redux";
import React, { FC, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import Sidebar from "../../Screen/Sidebar/Sidebar";
// import Sidebar from "../../Screen/ExchSimple/ExchSimple";
import Helmet1 from "../../modules/Loading/Helmet1";
import PreLoadingView from "../../modules/Loading/PreLoadingView";
import moment from "moment/moment";

import {
  get_wallets,
  get_markets_rates,
  get_histories_orderings,
  get_histories_orders,
  get_histories_transactions,
  get_markets_ohlcs,
} from "stores/Service/actions";
import { get_accounts } from "stores/Accounts/actions";
import NotificationAlert from "react-notification-alert";

import LoadingView from "../../modules/Loading/LoadingView";
import { getMessage } from "config/util";

import { InsideRoute } from "../Router";
import { post_variable } from "stores/API/actions";

function Route() {
  const dispatch = useDispatch();
  const ref = useRef();

  useEffect(() => {
    setTimeout(() => {
      dispatch(post_variable({ Sidebar: true }));
    }, 2000);
  }, []);

  const reduce_get_maps = useSelector((state) => state.reduce_get_maps);
  const reduce_post_authin = useSelector((state) => state.reduce_post_authin);
  const reduce_variable = useSelector((state) => state.reduce_variable);

  const toast = (error) => {
    const message = getMessage(error);
    dispatch_danger(message);
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_get_markets_rates = (data, page) => {
    dispatch(
      get_markets_rates({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_wallets = (data, page) => {
    dispatch(
      get_wallets({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_accounts = (data, page) => {
    dispatch(
      get_accounts({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_histories_orderings = (data, page) => {
    dispatch(
      get_histories_orderings({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_histories_orders = (data, page) => {
    dispatch(
      get_histories_orders({
        data,
        toast,
        page,
      })
    );
  };
  const dispatch_get_histories_transactions = (data, page) => {
    dispatch(
      get_histories_transactions({
        data,
        toast,
        page,
      })
    );
  };
  const dispatch_get_markets_ohlcs = (data, page) => {
    dispatch(
      get_markets_ohlcs({
        data,
        toast,
        page,
      })
    );
  };

  const [type, set_type] = useState(1440);
  const [limit, set_limit] = useState(100);

  var unix_zone =
    moment.utc("1988-04-12 00:00").unix() - moment("1988-04-12 00:00").unix();

  var unix_minute = type * 60;
  var unix_today = moment()
    .startOf("day")
    .unix();

  var unix_delta = moment().unix() - unix_today;
  var unix_count = (unix_delta / unix_minute) | 0;

  var unix_first = unix_today + (unix_count + 1 - limit) * unix_minute;
  var unix_last = unix_today + (unix_count + 1) * unix_minute;
  var unix_lastest = unix_today + unix_count * unix_minute;

  useEffect(() => {
    dispatch_get_accounts({}, () => {});
    dispatch_get_wallets({}, () => {});
    dispatch_get_markets_rates({}, () => {});
    dispatch_get_histories_orderings({ page: 1, limit: 10 });
    dispatch_get_histories_orders({ page: 1, limit: 10 });
    dispatch_get_histories_transactions({ page: 1, limit: 10 });
    dispatch_get_markets_ohlcs(
      {
        symbol: Object.keys(reduce_get_maps.coin_pairs.display)[0],
        type,
        unix_first,
        unix_last,
        unix_zone,
      },
      () => {}
    );
  }, [reduce_post_authin.token]);

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>
      {reduce_variable.Sidebar ? (
        <>
          <Sidebar />
          <InsideRoute />
        </>
      ) : (
        <PreLoadingView />
      )}
      <Helmet1 />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Roboto+Slab:400,700|Material+Icons"
        />
        <link
          rel="stylesheet"
          href="https://maxcdn.bootstrapcdn.com/font-awesome/latest/css/font-awesome.min.css"
        />
        <link
          id="Sidebar"
          rel="stylesheet"
          href="/dist/css/admin.css"
          onload="$('.Helmet1').hide()"
        />
        <title>SC WORLD EXCHANGE</title>
      </Helmet>
    </>
  );
}

export default Route;
